module.exports = {
    fi: {
        firstName: "Etunimi",
        lastName:"Sukunimi",
        phoneNumber:"Matkapuhelinnumero",
        email:"Sähköpostiosoite",
        emailAgain: "Sähköpostiosoite uudelleen",
        organizationName: "Organisaation ja yksikön nimi / Yrityksen nimi",
        departmentName: "Yksikön / toimipisteen nimi ja osoite",
        billingReferenceName: "Kustannuspaikka",
        code: "Koodi",
        notRequired: "Ei pakollinen.",
        send: "Lähetä",
        privateCustomer:"Olen yksityisasiakas",
        customerNotes: "Lisätiedot",
        choosePaymentOption: "Valitse maksutapa",
        paymentOptions14Days: "Lasku sähköpostitse tulkkauksen jälkeen, maksuaika 14 pv netto.",
        paymentOptionsBankCard: "Ennakkomaksu pankkikortilla",
        orderBillingAddress: "Kotiosoite",
        drivingSchoolTest: "Autokoulun teoriakoe tarjouspyyntö",
        legalInterpreter: "Tarjouspyyntö/oikeustulkki",
        chooseType: "Valitse tulkkauksen tyyppi:",
        typeInstant: "Etätulkki heti (puhelintulkkaus)",
        typeBooking: "Etätulkki ajanvarauksella (puhelintulkkaus)",
        typeOnSite: "Tulkki paikan päällä ajanvarauksella (läsnäolotulkkaus)",
        needSecurityCleared: "Tarvitsetko turvaselvitettyä tulkkia?",
        yes: "Kyllä",
        no: "Ei",
        locationLabel: "Ilmoita läsnäolotulkkauksen paikan osoite:",
        addressLabel: "Läsnäolotulkkauksen katuosoite",
        mailingAddressLabel: "Postinumero",
        mailingCityLabel: "Postitoimipaikka",
        locationInfo: "Lisätietoa tulkkauksen sijainnista",
        skills: "Kielitaito (mainitse: A=äidinkieli (vain 1), B=aktiivinen vieras kieli, C=passiivinen vieras kieli)",
        childhoodEducationInterpreter: "Tarjouspyyntö/varhaiskasvatus",
        healthInterpreter: "Tarjouspyyntö/terveystulkki",
        businessInterpreter: "Tarjouspyyntö/bisnestulkki",
        mentalHealthInterpreter: "Tarjouspyyntö/mielenterveystulkki",
        chooseDocument: "Valitse tiedosto",
        CV: "CV",
    },
    en: {
        firstName: "First name",
        lastName:"Last name",
        phoneNumber:"Phone number (including country code)",
        email:"Email",
        emailAgain: "Email again",
        organizationName: "Organization name",
        departmentName: "Department name",
        billingReferenceName: "Cost center",
        code: "Code",
        notRequired: "Not required.",
        send: "Send",
        privateCustomer:"Private customer",
        customerNotes: "Additional information",
        drivingSchoolTest: "Driving school theory test offer request",
        paymentOptions14Days: "Invoice by email 14 days after interpretation net.",
        paymentOptionsBankCard: "Payment in advance by bank card",
        legalInterpreter: "Offer request/legal interpreter",
        orderBillingAddress: "Home address",
        paymentOptions14Days: "Invoice by email 14 days after interpretation net.",
        skills: "List all the languages you interpret",
        addressLabel: "On-site interpretation address",
        mailingAddressLabel: "Mailing address",
        mailingCityLabel: "Mailing city",
        locationInfo: "Additional information about the location of the interpretation",
    },
    ru: {
        firstName: "Имя",
        lastName:"Фамилия",
        phoneNumber:"Номер мобильного телефона",
        email:"Адрес электронной почты",
        emailAgain: "TODO",
        organizationName: "Организация/ компания",
        departmentName: "Название отдела",
        code: "Код",
        notRequired: "Необязательное поле",
        send: "Отправить",
        billingReferenceName: "Подразделение",
        privateCustomer:"Я частный клиент",
        customerNotes: "Дополнительная информация",
        choosePaymentOption: "Выберите способ оплаты",
        paymentOptions14Days: "Счет по электронной почте после перевода, период оплаты 14 календарных дней.",
        paymentOptionsBankCard: "Предоплата по банковской карте",
        orderBillingAddress: "Домашний адрес",
        drivingSchoolTest: "Запрос стоимости перевода экзамена по теории вождения",
        legalInterpreter: "Запрос стоимости перевода в суде",
        chooseType: "Выберите тип перевода:",
        typeInstant: "Срочный перевод по телефону прямо сейчас",
        typeBooking: "Перевод по телефону по предварительной записи",
        typeOnSite: "Перевод по предварительной записи на месте",
        needSecurityCleared: "Требуется переводчик, прошедший проверку в органах безопасности?",
        yes: "Да",
        no: "Нет",
        locationLabel: "Укажите адрес места, где состоится мероприятие с устным переводом:",
        addressLabel: "Адрес места перевода (улица)",
        mailingAddressLabel: "Индекс",
        mailingCityLabel: "Почтовое отделение (город)",
        locationInfo: "Дополнительные сведения о месте перевода",
        skills: "Языки переводчика (каждый язык пометьте как A - родной, B - активный иностранный или C - пассивный иностранный)",
        childhoodEducationInterpreter: "Запрос стоимости перевода по теме дошкольное образование",
        healthInterpreter: "Запрос стоимости перевода по теме здравоохранение",
        businessInterpreter: "Запрос стоимости бизнес-перевода",
        chooseDocument: "Выберите файл",
        CV: "Резюме",
        
    },

    sv: {
        firstName:"Förnamn",
        lastName:"Efternamn",
        phoneNumber:"Telefonnummer",
        email:"E-postadress",
        emailAgain: "Bekräfta e-postadressen",
        organizationName: "Namn på organisationen och enheten / Företagets namn",
        departmentName: "Namn och adress för Enhet / Kontor",
        billingReferenceName: "Kostnadsställe",
        code: "Code",
        notRequired: "Inte obligatorisk.",
        send: "Skicka",
        privateCustomer:"Private customer",
        customerNotes: "Additional information",
        drivingSchoolTest: "Driving school theory test offer request",
        paymentOptions14Days: "Invoice by email 14 days after interpretation net.",
        paymentOptionsBankCard: "Payment in advance by bank card",
        legalInterpreter: "Offer request/legal interpreter",
        orderBillingAddress: "Home address",
        paymentOptions14Days: "Invoice by email 14 days after interpretation net.",
        skills: "Språkkunskaper: (nämn modersmål A (bara ett), B: aktivt främmande språk, C: passiv främmande språk)",
        addressLabel: "Kontakttolkningens gatuadress",
        mailingAddressLabel: "Postnummer",
        mailingCityLabel: "ort",
        locationInfo: "Mer information om kontakttolkningens plats",
    },
    de: {
        firstName: "Vorname",
        lastName:"Nachname",
        phoneNumber:"Handynummer mit ländervorwahl",
        email:"E-mail-Adresse",
        emailAgain: "E-Mail-Adresse bestätigen",
        organizationName: "Name der Organisation / des Unternehmens",
        departmentName: "Yksikön / toimipisteen nimi ja osoite",
        billingReferenceName: "Kustannuspaikka",
        code: "Koodi",
        notRequired: "Ei pakollinen.",
        send: "Senden",
        privateCustomer:"Olen yksityisasiakas",
        customerNotes: "Lisätiedot",
        choosePaymentOption: "Valitse maksutapa",
        paymentOptions14Days: "Lasku sähköpostitse tulkkauksen jälkeen, maksuaika 14 pv netto.",
        paymentOptionsBankCard: "Ennakkomaksu pankkikortilla",
        orderBillingAddress: "Kotiosoite",
        drivingSchoolTest: "Autokoulun teoriakoe tarjouspyyntö",
        legalInterpreter: "Tarjouspyyntö/oikeustulkki",
        chooseType: "Valitse tulkkauksen tyyppi:",
        typeInstant: "Etätulkki heti (puhelintulkkaus)",
        typeBooking: "Etätulkki ajanvarauksella (puhelintulkkaus)",
        typeOnSite: "Tulkki paikan päällä ajanvarauksella (läsnäolotulkkaus)",
        needSecurityCleared: "Tarvitsetko turvaselvitettyä tulkkia?",
        yes: "Kyllä",
        no: "Ei",
        locationLabel: "Ilmoita läsnäolotulkkauksen paikan osoite:",
        addressLabel: "Adresse der vor Ort-Verdolmetschung ",
        mailingAddressLabel: "Postleitzahl",
        mailingCityLabel: "Ort",
        locationInfo: "Zusatzinformation über den Ort der Verdolmetschung",
        skills: "Sprachkenntnisse: (geben Sie an: A: Muttersprache (nur eine), B: eine aktive Fremdsprache, C: passive Fremdsprache(n)",
        childhoodEducationInterpreter: "Tarjouspyyntö/varhaiskasvatus",
        healthInterpreter: "Tarjouspyyntö/terveystulkki",
        businessInterpreter: "Tarjouspyyntö/bisnestulkki",
        chooseDocument: "Valitse tiedosto",
        CV: "CV",
    },
    is: {
        firstName : "Fornafn",
        lastName : "Eftirnafn",
        phoneNumber : "Símanúmer",
        email : "Netfang",
        emailAgain : "Staðfestu netfangið þitt",
        organizationName : "Heiti fyrirtækis",
        departmentName : "Svið innan fyrirtækis",
        billingReferenceName : "Kostnaðarstaður",
        code : "Kóði",
        send : "Senda",
        privateCustomer : "Viðskiptavinur sem er einstaklingur",
        customerNotes : "Viðbótarupplýsingar",
        drivingSchoolTest : "Biðja um verðtilboð í túlkaþjónustu fyrir bóklegt bílpróf",
        paymentOptions14Days : "Fá reikning í tölvupósti 14 dögum eftir að túlkun fer fram.",
        paymentOptionsBankCard : "Fyrirframgreiðsla með korti",
        legalInterpreter : "Beiðni um verðtilboð/löggiltur túlkur",
        orderBillingAddress : "Heimilisfang",
        paymentOptions14Days : "Fá reikning í tölvupósti 14 dögum eftir að túlkun fer fram.",
        skills : "Tungumálakunnátta",
        addressLabel : "Heimilisfang þar sem túlkunin fer fram",
        mailingAddressLabel : "Póstnúmer",
        mailingCityLabel : "Borg",
        locationInfo : "Viðbótarupplýsingar um staðinn þar sem túlkunin fer fram",
    },
    ee: {
        firstName : "TODO",
        lastName : "TODO",
        phoneNumber : "TODO",
        email : "TODO",
        emailAgain : "TODO",
        organizationName : "TODO",
        departmentName : "TODO",
        billingReferenceName : "TODO",
        code : "TODO",
        send : "TODO",
        privateCustomer : "TODO",
        customerNotes : "TODO",
        drivingSchoolTest : "TODO",
        paymentOptions14Days : "TODO",
        paymentOptionsBankCard : "TODO",
        legalInterpreter : "TODO",
        orderBillingAddress : "TODO",
        paymentOptions14Days : "TODO",
        skills : "TODO",
        addressLabel : "TODO",
        mailingAddressLabel : "TODO",
        mailingCityLabel : "TODO",
        locationInfo : "TODO",
    },

};